import React from "react";
import { NakiNigunArtistUnavailableInAppTemplate } from "themes/application/common/components";

function NakiNigunArtistUnavailableInApp(props) {
    return <NakiNigunArtistUnavailableInAppTemplate {...props} />;
}

export default NakiNigunArtistUnavailableInApp;
